module.exports = __webpack_public_path__ + "static/img/yinxianghua.b296cd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/yinxianghua.png
// module id = gEYH
// module chunks = 0